import React, { ReactNode } from 'react'

import { useGetSiteUrl } from '@application/Interfaces/Hooks/useGetSiteUrl'
import { isInternalUrl, isRelativeUrl } from '@src/Application/Utils/BrowserUtils'
import { ensureForwardSlash } from '@src/Infrastructure/Url/ensureForwardSlash'
import { ensureTrailingSlash } from '@src/Infrastructure/Url/ensureTrailingSlash'

import { A, GLink } from './Link.styled'

type LinkProp = {
    to: string
    children: ReactNode
    type?: 'small' | 'medium'
    underline?: boolean
    className?: string
    title?: string
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

export const Link = ({ children, to, type = 'medium', underline = false, ...rest }: LinkProp): JSX.Element => {
    const siteUrl = useGetSiteUrl()
    const isInternal = isInternalUrl({ url: to, siteUrl })

    if (isRelativeUrl(to)) {
        return (
            <GLink to={ensureForwardSlash(ensureTrailingSlash(to))} $type={type} $underline={underline} {...rest}>
                {children}
            </GLink>
        )
    }

    return (
        <A
            target={isInternal ? '_self' : '_blank'}
            rel={isInternal ? undefined : 'noreferrer noopener'}
            href={to}
            $type={type}
            $underline={underline}
            {...rest}
        >
            {children}
        </A>
    )
}
